import { render, staticRenderFns } from "./Attributions.vue?vue&type=template&id=0093a480"
import script from "./Attributions.vue?vue&type=script&lang=js"
export * from "./Attributions.vue?vue&type=script&lang=js"
import style0 from "./Attributions.vue?vue&type=style&index=0&id=0093a480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports